<template>

  <div>
    <div class="mb-2">
      {{ display }}
    </div>
    <vue-slider
      :min="min"
      :max="max"
      :interval="interval"
      :enable-cross="false"
      v-model="tValue"
      @drag-end="change">
      </vue-slider>
  </div>

</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  name: 'SliderRange',
  components: {
    vueSlider
  },
  props: {
    'value': {
      type: Array,
      default: null
    },
    'min': {
      type: Number,
      default: 0
    },
    'max': {
      type: Number,
      default: 100
    },
    'interval': {
      type: Number,
      default: 1
    },
    'format': {
      type: String,
      default: '{value}'
    }
  },
  data () {
    return {
      tValue: this.getSimulateValue(this.value)
    }
  },
  computed: {
    display () {
      const start = this.tValue ? this.tValue[0] : null
      const end = this.tValue ? this.tValue[1] : null
      return this.format.replace('{value}', start) + ' - ' + this.format.replace('{value}', end)
    }
  },
  watch: {
    value: function (val) {
      this.tValue = this.getSimulateValue(val)
    }
  },
  methods: {
    change () {
      const val = (this.tValue[0] === this.min && this.tValue[1] === this.max) ? null : this.tValue
      this.$emit('input', val)
    },
    getSimulateValue (value) {
      return value || [this.min, this.max]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SliderRange.vue